export const toPlainText = (value: string) =>
  value
    .replace(/<[^>]*>/g, " ")
    .replace(/[#_*`>\-\n]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
